
import React from "react";
import { Button } from "@/components/ui/button";
import {
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  Link,
  Image,
  List,
  ListOrdered,
  Code,
  Undo,
  Redo,
  Maximize2,
  Minimize2,
  Puzzle
} from "lucide-react";

interface ToolbarAction {
  icon: React.ReactNode;
  title: string;
  action: (e: React.MouseEvent) => void;
}

interface EditorToolbarProps {
  toolbarActions: ToolbarAction[];
  toolbarToolActions?: ToolbarAction[];
  handleUndo: (e: React.MouseEvent) => void;
  handleRedo: (e: React.MouseEvent) => void;
  isFullScreen: boolean;
  showPreview: boolean;
  toggleFullScreen: (e: React.MouseEvent) => void;
  togglePreview?: (e: React.MouseEvent) => void;
}

const EditorToolbar: React.FC<EditorToolbarProps> = ({
  toolbarActions,
  toolbarToolActions = [],
  handleUndo,
  handleRedo,
  isFullScreen,
  showPreview,
  toggleFullScreen,
  togglePreview
}) => {
  return (
    <div className="border-b border-border flex justify-between items-center p-2 bg-muted/50">
      <div className="flex flex-wrap gap-1">
        {toolbarActions.map((action, index) => (
          <Button
            key={index}
            variant="ghost"
            size="sm"
            className="h-8 w-8 p-0"
            onClick={action.action}
            title={action.title}
            type="button"
          >
            {action.icon}
          </Button>
        ))}
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
          onClick={handleUndo}
          title="Undo"
          type="button"
        >
          <Undo size={18} />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
          onClick={handleRedo}
          title="Redo"
          type="button"
        >
          <Redo size={18} />
        </Button>
        
        {toolbarToolActions.length > 0 && (
          <>
            <div className="h-6 border-l border-border mx-1"></div>
            {toolbarToolActions.map((action, index) => (
              <Button
                key={`tool-${index}`}
                variant="ghost"
                size="sm"
                className="h-8 px-2 flex items-center gap-1"
                onClick={action.action}
                title={action.title}
                type="button"
              >
                {action.icon}
                <span className="hidden sm:inline text-xs">Tool</span>
              </Button>
            ))}
          </>
        )}
      </div>
      <div className="flex items-center space-x-2">
        {isFullScreen && togglePreview && (
          <Button
            variant="outline"
            size="sm"
            onClick={togglePreview}
            type="button"
          >
            {showPreview ? "Hide Preview" : "Show Preview"}
          </Button>
        )}
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
          onClick={toggleFullScreen}
          title={isFullScreen ? "Exit Full Screen" : "Full Screen"}
          type="button"
        >
          {isFullScreen ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
        </Button>
      </div>
    </div>
  );
};

export default EditorToolbar;
